/* tp-collection-ui v1 (2026-10-25). Vanilla, no dependencies. Enhances sections/tp-main-collection:
   category row edge fades, accordion memory, mobile sheet a11y, live "Show N results". Filtering itself stays in assets/filters.js. */
(function () {
  'use strict';
  var D = document, W = window, KEY = 'tpc-closed';
  function mobile() { return W.innerWidth < 768; }

  /* ---- category row: edge fades ---- */
  function navInit() {
    D.querySelectorAll('[data-tpn]').forEach(function (nav) {
      if (nav.__tpn) return; nav.__tpn = 1;
      var l = nav.querySelector('.tpn__list'); if (!l) return;
      function edges() {
        var max = l.scrollWidth - l.clientWidth, x = l.scrollLeft;
        nav.classList.toggle('has-l', x > 4);
        nav.classList.toggle('has-r', max - x > 4);
      }
      edges();
      l.addEventListener('scroll', edges, { passive: true });
      W.addEventListener('resize', edges, { passive: true });
      if (W.ResizeObserver) new ResizeObserver(edges).observe(l);
    });
  }

  /* ---- filters ---- */
  var seq = 0;
  function countUrl(cont, form) {
    var p = new URLSearchParams(new FormData(form)).toString();
    return W.location.pathname + '?section_id=' + encodeURIComponent(cont.dataset.id) + '&' + p;
  }
  function filtersInit() {
    var cont = D.getElementById('CollectionProductsContainer'); if (!cont) return;
    var st = {}; try { st = JSON.parse(sessionStorage.getItem(KEY) || '{}'); } catch (e) {}
    cont.querySelectorAll('details.tpc-d').forEach(function (d) {
      var k = d.dataset.k;
      if (st[k] === 1) d.open = false;
      if (!d.__t) {
        d.__t = 1;
        d.addEventListener('toggle', function () {
          if (d.open) delete st[k]; else st[k] = 1;
          try { sessionStorage.setItem(KEY, JSON.stringify(st)); } catch (e) {}
        });
      }
    });

    var form = D.getElementById('FiltersForm');
    if (form && !form.__tpc) {
      form.__tpc = 1;
      var timer;
      form.addEventListener('change', function () {
        if (!mobile()) return;
        clearTimeout(timer);
        timer = setTimeout(function () {
          var btn = form.querySelector('[data-tpc-n]'); if (!btn) return;
          var my = ++seq;
          fetch(countUrl(cont, form)).then(function (r) { return r.text(); }).then(function (html) {
            if (my !== seq) return;
            var m = html.match(/class="products-count[^"]*"[^>]*>\s*([\d,.]+)/);
            if (m) btn.textContent = m[1];
          }).catch(function () {});
        }, 220);
      });
    }

    var aside = D.getElementById('filterSideBar');
    if (aside && !aside.__tpc) {
      aside.__tpc = 1;
      aside.addEventListener('keydown', function (e) {
        if (!mobile() || !aside.classList.contains('active')) return;
        if (e.key === 'Escape') { var c = D.getElementById('cancelFilters'); if (c) c.click(); return; }
        if (e.key !== 'Tab') return;
        var f = aside.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),summary,[tabindex="0"]');
        f = Array.prototype.filter.call(f, function (n) { return n.offsetParent !== null; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && D.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && D.activeElement === last) { e.preventDefault(); first.focus(); }
      });
      new MutationObserver(function () {
        if (!mobile()) return;
        var open = aside.classList.contains('active');
        aside.setAttribute('role', 'dialog'); aside.setAttribute('aria-modal', 'true'); aside.setAttribute('aria-label', 'Filters');
        if (open) { var c = D.getElementById('cancelFilters'); if (c) c.focus(); }
        else if (aside.__was) { var h = D.getElementById('filterHeading'); if (h && h.focus) h.focus(); }
        aside.__was = open;
      }).observe(aside, { attributes: true, attributeFilter: ['class'] });
    }
    headingA11y();
    sortA11y();
    badge(cont);
  }
  /* keep the toolbar's active-filter badge in step after AJAX swaps (the toolbar is outside the swapped container) */
  function badge(cont) {
    var n = cont.querySelectorAll('.yv-products-applied-filter .yv-applied-filter-item:not(.tpc-chip-clear)').length;
    var h = D.getElementById('filterHeading'); if (!h) return;
    var b = h.querySelector('.tpc-badge');
    if (n > 0) {
      if (!b) { b = D.createElement('span'); b.className = 'tpc-badge'; h.appendChild(b); }
      b.textContent = n; b.setAttribute('aria-label', n + ' active');
    } else if (b) b.remove();
  }

  /* "Filter" label is a div in the theme: give it button semantics on mobile only (it is a label on desktop) */
  function headingA11y() {
    var h = D.getElementById('filterHeading'); if (!h) return;
    if (mobile()) {
      h.setAttribute('role', 'button'); h.setAttribute('tabindex', '0');
      h.setAttribute('aria-haspopup', 'dialog'); h.setAttribute('aria-controls', 'filterSideBar');
      if (!h.__k) { h.__k = 1; h.addEventListener('keydown', function (e) { if (mobile() && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); h.click(); } }); }
    } else {
      h.removeAttribute('role'); h.removeAttribute('tabindex'); h.removeAttribute('aria-haspopup'); h.removeAttribute('aria-controls');
    }
  }
  function sortA11y() {
    var b = D.querySelector('.collection-sortby-selected'), l = D.getElementById('sort__list'); if (!b || !l) return;
    b.setAttribute('aria-haspopup', 'listbox'); b.setAttribute('aria-controls', 'sort__list');
    function sync() { b.setAttribute('aria-expanded', l.classList.contains('active') ? 'true' : 'false'); }
    sync();
    if (!l.__tpc) {
      l.__tpc = 1;
      new MutationObserver(sync).observe(l, { attributes: true, attributeFilter: ['class'] });
      l.addEventListener('keydown', function (e) { if (e.key === 'Escape' && l.classList.contains('active')) { b.click(); b.focus(); } });
    }
  }

  function init() {
    navInit(); filtersInit();
    var cont = D.getElementById('CollectionProductsContainer');
    if (cont && !cont.__tpcObs) {
      cont.__tpcObs = 1;
      new MutationObserver(function () { filtersInit(); }).observe(cont, { childList: true });
    }
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', init); else init();
  W.addEventListener('resize', headingA11y, { passive: true });
})();
